import type { ApiResponse, PagedResponseDto } from "@/types/common";
import type {
  CommissionDistributionFilterParams,
  CommissionDistributionItemDto,
  CommissionDistributionRunResultDto,
  IncomeEntryDto,
  IncomeReportFilterParams,
  IncomeSummaryDto,
} from "@/types/income.dto";
import { apiClient, unwrapApiResponse } from "./httpClient";

export const incomeService = {
  getSummary(): Promise<IncomeSummaryDto> {
    return unwrapApiResponse(apiClient.get<ApiResponse<IncomeSummaryDto>>("/Income/summary"));
  },

  getEntries(filter: IncomeReportFilterParams = {}): Promise<PagedResponseDto<IncomeEntryDto>> {
    return unwrapApiResponse(
      apiClient.get<ApiResponse<PagedResponseDto<IncomeEntryDto>>>("/Income/entries", {
        params: filter,
      }),
    );
  },

  getAdminSummary(): Promise<IncomeSummaryDto> {
    return unwrapApiResponse(
      apiClient.get<ApiResponse<IncomeSummaryDto>>("/Income/admin/summary"),
    );
  },

  getAdminEntries(
    filter: IncomeReportFilterParams = {},
  ): Promise<PagedResponseDto<IncomeEntryDto>> {
    return unwrapApiResponse(
      apiClient.get<ApiResponse<PagedResponseDto<IncomeEntryDto>>>("/Income/admin/entries", {
        params: filter,
      }),
    );
  },

  getAdminDistribution(
    filter: CommissionDistributionFilterParams = {},
  ): Promise<PagedResponseDto<CommissionDistributionItemDto>> {
    return unwrapApiResponse(
      apiClient.get<ApiResponse<PagedResponseDto<CommissionDistributionItemDto>>>(
        "/Income/admin/distribution",
        { params: filter },
      ),
    );
  },

  runDueDistribution(): Promise<CommissionDistributionRunResultDto> {
    return unwrapApiResponse(
      apiClient.post<ApiResponse<CommissionDistributionRunResultDto>>("/Income/admin/distribution/run"),
    );
  },

  distributeOrder(orderId: number, force = false): Promise<boolean> {
    return unwrapApiResponse(
      apiClient.post<ApiResponse<boolean>>(`/Income/admin/distribution/${orderId}`, null, {
        params: { force },
      }),
    );
  },
};
